<template>
  <el-dialog
    title=""
    :visible.sync="cashShow"
    width="360px"
    :before-close="handleClose"
    :append-to-body="true"
    class="cashDialog"
    :close-on-click-modal="false"
  >
    <div class="content">
      <img
        ref="cashImgRef"
        @load="handleImageLoad"
        style="width: 360px"
        :src="cashImg"
        alt=""
      />
      <fm-button class="cashButton" @click="confirm" round size="medium">{{
        buttonText
      }}</fm-button>

      <div class="btn-svg">
        <svg-btn
          style="width: 14;cursor: pointer;"
          @click="checkArchives"
          :icon-class="isChecked ? 'icon-file-check' : 'icon-file-uncheck2'"
        >
        </svg-btn>
        <span class="sspan">今日不再弹出</span>
      </div>
      <svg-btn
        @click="handleClose"
        :class="height < 340 ? 'close-icon' : 'close-icon2'"
        icon-class="icon-cash-close"
      />
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    cashShow: {
      type: Boolean,
      default: false,
    },
    cashType: {
      type: String || Number,
      default: 2,
    },
    cashImg: {
      type: String,
      default: "",
    },
    buttonText: {
      type: String,
      default: "立即收下",
    },
  },
  data() {
    return {
      height: 0,
      isChecked: false,
    };
  },
  created() {},
  methods: {
    //勾选协议
    checkArchives() {
      this.isChecked = !this.isChecked;
    },
    handleImageLoad() {
      const img = this.$refs.cashImgRef;
      if (img) {
        this.height = img.clientHeight; // 获取实际渲染高度
      }
    },
    confirm() {
      this.$emit("confirm", this.isChecked);
    },
    handleClose() {
      this.$emit("handleClose", this.isChecked);
    },
  },
};
</script>

<style lang="scss" scoped>
.cashDialog {
  ::v-deep .el-dialog {
    box-shadow: none !important;
    background: transparent !important;
  }
  ::v-deep .el-dialog__body {
    padding: 0 !important;
  }
  .content {
    position: relative;
    background-repeat: no-repeat;
    width: 360px;
    background-size: contain;
    background-position: center;

    .btn-svg {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      position: absolute;
      left: 50%;
      bottom: -116px;
      transform: translate(-50%, -50%);

      .sspan {
        margin-left: 8px;
        line-height: 20px;
        height: 20px;
        font-size: 12px;
        color: #ffffff;
        -webkit-user-select: none; /* Chrome/Safari */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* IE10+ */
        user-select: none; /* 标准语法 */
      }
    }
    .cashButton {
      background: linear-gradient(137deg, #fd513a 0%, #fe4162 100%);
      position: absolute;
      left: 50%;
      bottom: -97px;
      transform: translate(-50%, -50%);
      width: 168px;
      height: 48px;
      border-radius: 24px;
      font-weight: 600;
      font-size: 18px;
      color: #ffffff;
      line-height: 28px;
    }
    .close-icon {
      width: 28px;
      height: 28px;
      position: absolute;
      right: -28px;
      top: -28px;
      cursor: pointer;
    }
    .close-icon2 {
      width: 28px;
      height: 28px;
      position: absolute;
      right: -18px;
      top: -6px;
      cursor: pointer;
    }
  }
}
</style>
